import React from 'react';

const ContentFilterSection = ({ settings, setSettings }) => (
  <div style={{ padding: 15, background: '#475569', borderRadius: 10 }} data-testid="content-filter-section">
    <div style={{ marginBottom: 12 }}>
      <strong style={{ color: '#047857' }}><i className="fas fa-shield-alt" style={{ marginRight: 6 }} /> Content Filtering</strong>
      <p style={{ fontSize: '0.8rem', color: '#a1a1aa', marginTop: 4 }}>
        Control what type of content appears in your search results. This allows you to research adult topics including sexual positions, techniques, supplements, devices, and technology.
      </p>
    </div>
    
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {[
        { value: 'strict', icon: 'fa-shield-alt', label: 'Strict (Default)', desc: 'Family-friendly content only. Adult content is filtered out.', color: '#10b981', bgColor: '16,185,129' },
        { value: 'moderate', icon: 'fa-exclamation-triangle', label: 'Moderate', desc: 'Allow educational and health-related adult content. Explicit content filtered.', color: '#f59e0b', bgColor: '245,158,11' },
        { value: 'off', icon: 'fa-lock-open', label: 'Off (Adult Content Enabled)', desc: 'No filtering. Research sexual positions, techniques, supplements, devices, and technology freely.', color: '#ef4444', bgColor: '239,68,68' }
      ].map(opt => (
        <label key={opt.value} style={{
          display: 'flex', alignItems: 'center', gap: 12, cursor: 'pointer', padding: '10px 12px',
          background: settings.content_filter === opt.value ? `rgba(${opt.bgColor},0.2)` : 'rgba(0,0,0,0.2)',
          borderRadius: 8,
          border: settings.content_filter === opt.value ? `1px solid rgba(${opt.bgColor},0.5)` : '1px solid transparent'
        }} data-testid={`content-filter-${opt.value}`}>
          <input type="radio" name="content_filter" value={opt.value}
            checked={settings.content_filter === opt.value}
            onChange={(e) => setSettings({ ...settings, content_filter: e.target.value })}
            style={{ accentColor: opt.color }} />
          <div>
            <span style={{ color: opt.color, fontWeight: 600 }}>
              <i className={`fas ${opt.icon}`} style={{ marginRight: 4 }} /> {opt.label}
            </span>
            <p style={{ fontSize: '0.75rem', color: '#71717a', marginTop: 2, marginBottom: 0 }}>{opt.desc}</p>
          </div>
        </label>
      ))}
    </div>
    
    {settings.content_filter === 'off' && (
      <div style={{ marginTop: 12, padding: 10, background: 'rgba(239,68,68,0.1)', borderRadius: 8, border: '1px solid rgba(239,68,68,0.3)' }}>
        <p style={{ color: '#fca5a5', fontSize: '0.75rem', margin: 0 }}>
          <i className="fas fa-exclamation-triangle" style={{ marginRight: 4 }} />
          <strong>Adult Content Warning:</strong> You have enabled unrestricted content. This allows research on sexual topics. You must be 18+ to use this setting.
        </p>
      </div>
    )}
  </div>
);

export default ContentFilterSection;
